<template>
  <div class="detail clearfix">
      <div class="banner"><img src="./banner-introduce.jpg" alt="" width="100%"></div>
      <!-- {{$route.params.name}} -->
    <div class="main">
    <p class="current-local">
          <a href='/'><span>走进亚商</span></a>
          <span class="arrow-bold"> &gt; </span>
          <span v-if="$route.params.name === 'introduce'">亚商简介</span>
          <span v-else-if="$route.params.name === 'developHistory'">发展历程</span>
          <span v-else-if="$route.params.name === 'founder'">核心团队</span>
          <span v-else-if="$route.params.name === 'contactUs'">联系我们</span>
          <span v-else-if="$route.params.name === 'joinUs'">加入我们</span>
    </p>
    <Sidebar></Sidebar>
    <div class="detail-cont fr">
      <div class="detail-content" v-if="$route.params.name === 'introduce'">
        <div class="introduce">
            <p class="title">亚商集团简介</p>
            <p style="text-indent:2em;">上海亚商发展集团有限公司成立于1988年，前身为上海亚洲商务投资咨询公司。亚商深耕中国资本市场30年，擅长以产业投资和增值服务为合作方大幅度提升战略价值，是市场诸多创新的首倡者与实践者，并逐渐成长为中国本土最优秀的具备产业整合和金融资本战略性运作能力的资本集团之一。</p>
            <p style="text-indent:2em;">亚商过去三十年来已与十多个省市级政府和数百家大型企业集团、上市公司和优秀民营企业开展各类战略合作以及专业服务，并成功操作多起大型并购交易，涉及金额超过1000亿人民币。</p>
            <!-- <p><img src="./introduce.jpg" alt="" width="880"></p> -->
            <p class="summary" style="text-indent:2em;">亚商集团对于中国的经济、企业、行业发展和特色商业文化有着深刻而独到的理解，始终领行业风气之先，同时在投资过程中注重被投资企业的持续成长能力和未来资本市场溢价，作风稳健，业绩辉煌，收获广泛赞誉。</p>
        </div>
      </div>
      <div v-else-if="$route.params.name === 'developHistory'" class="developHistory">
        <ul class="oneList">
            <li v-for="(item, index) in dateList" :key="index" :class="{'active': index === dateIndex}" @click="tabNav(index)">{{item}}</li>
        </ul>
        <ul v-if="dateIndex === 0" class="childDateList">
            <li v-for="(item, index) in childDateListLatest" :key="index" :class="{'active': index === childDateIndex}" @click="tabChildNav(index)">{{item}}</li>
        </ul>
        <ul v-if="dateIndex === 1" class="childDateList">
            <li v-for="(item, index) in childDateList1" :key="index" :class="{'active': index === childDateIndex}" @click="tabChildNav(index)">{{item}}</li>
        </ul>
        <ul v-else-if="dateIndex === 2" class="childDateList">
            <li v-for="(item, index) in childDateList2" :key="index" :class="{'active': index === childDateIndex}" @click="tabChildNav(index)">{{item}}</li>
        </ul>
        <ul v-else-if="dateIndex === 3" class="childDateList">
            <li v-for="(item, index) in childDateList3" :key="index" :class="{'active': index === childDateIndex}" @click="tabChildNav(index)">{{item}}</li>
        </ul>
        <div class="line"></div>
        <div class="majorEvent"> <!--   v-if="dateIndex == 0 && childDateIndex == 0" -->
            <div class="events" v-for="(items, index) in events[dateIndex][childDateIndex]" :key="index">
                <p>{{items.text}}</p>
                <!-- <p>{{events[dateIndex][childDateIndex].text2}}</p>
                <p>{{events[dateIndex][childDateIndex].text3}}</p> -->
            </div>
        </div>
      </div>
      <div v-else-if="$route.params.name === 'founder'" class="founder">
          <div class="founder1 clearfix">
            <p class="title">陈琦伟 教授</p>
            <p class="founder-intro fl">陈琦伟教授是亚商集团的创始人兼董事长，同时也是中国著名的国际金融学家和资本市场专家；其专业代表作《国际竞争论》曾于1986年荣获第二届“孙冶方经济学优秀著作奖”，轰动了当时的中国经济学界。在创办亚商之后，陈琦伟先生也成为了国内最早一批将学术理论知识付之于商业实践的学者型企业家，并且在随后的三十年间通过一系列实际操作的中国企业上市，上市公司收购兼并和重组以及VC和PE投资的案例，带领亚商成长为国内享有盛名的资产管理和企业策略服务集团，体现了洞察中国经济金融资本市场主流商业机会的前瞻力。</p>
            <p class="founder-intro fl">陈琦伟教授在政府和商界拥有广泛的影响力，并且与国内外多位著名企业家及工商界高层人士保持着深厚的个人友谊；曾先后担任交通大学安泰经济与管理学院教授、华东师范大学国际金融系教授、上海股权投资协会理事长、中国创业资本研究中心主任，亚洲开发银行和中国国家开发银行特别顾问。陈琦伟先生目前也是亚布力中国企业家论坛理事、上海证券交易所专家委员，以及多家金融机构和上市公司的独立董事。</p>
            <div class="founder-pic fr"><img src="./founder-pic.png" alt=""></div>
          </div>
          <div class="founder1 clearfix">
              <p class="title">张琼 女士</p>
            <p class="founder-intro fl">亚商集团联席总裁，亚商资本创始合伙人，在创新消费和消费升级领域具有丰富的经验。美国斯坦福大学商学院MSX管理学硕士，7天连锁酒店（现更名为铂涛集团并被锦江集团收购）创始人之一。曾作为亚商咨询的创始人之一和总裁，策划、主持和参与了中远收购众城，上房收购嘉丰，统一参股完达山乳业等数十起企业改制、战略性重组和购并、跨国购并以及购并后整合、企业战略规划与管理变革、海外融资与跨国购并等大型项目。张琼女士主导了包括中航三鑫、福建圣农、升达林业、丽家宝贝等多家高成长优质企业的股权投资。</p>
            <p class="founder-intro fl">张琼女士现任中国股权投资基金协会副会长、上海市创业投资行业协会理事、曾任上海市金融青年联合会常委，并荣获由China Venture授予的“2010年中国十大最佳创业投资人”、“杰出管理成就奖”、“卓越管理专家”称号以及“100大品牌女性人物” 殊荣，在国内外工商界有广泛和高端的联系。</p>
            <div class="founder-pic fr"><img src="./zq.png" alt=""></div>
          </div>
      </div>
      <div v-else-if="$route.params.name === 'contactUs'" class="contactUs">
          <ul v-for="(item, index) in addrList" :key="index">
              <li class="title">{{item.addrName}}</li>
              <li class="addrDetail">{{item.addrDetail}}</li>
              <li class="telephone"><span class="mr20">{{item.telephone}}</span><span>{{item.fax}}</span></li>
          </ul>
          <div class="map-box">
            <div class="map"><img src="./abc-map.png" alt="亚商集团"></div>
            <!--<MapContainer id-name="amap1" :center="[121.397155, 31.198411]" label="亚商集团"></MapContainer>-->
            <p class="mb96">亚商集团&亚商资本地址</p>
            <div class="map"><img src="./tougu-map.png" alt="亚商投顾"></div>
            <!--<MapContainer id-name="amap2" :center="[121.406694, 31.257277]" label="亚商智讯"></MapContainer>-->
            <p class="mb96">亚商投顾&亚商智讯地址</p>
            <div class="map"><img src="./abc-capital-map.jpg" alt="亚商资本"></div>
            <!--<MapContainer id-name="amap3" :center="[113.943981, 22.549438]" label="亚商资本(深圳)"></MapContainer>-->
            <p>亚商资本(深圳)地址</p>
          </div>
      </div>
      <div v-else-if="$route.params.name === 'joinUs'" class="joinUs">
        <img src="./join-us.jpg" alt="" style="width: 830px">
        <div class="company-item">
          <div class="tab-main" style="padding:26px 21px 39px;">
            <div class="requirement" style="border-bottom: 1px solid #9F9F9F;padding-bottom: 10px;">
              <div :class="departmentAction === departmentItem.name ? 'requirement department-title department-title-action' : 'requirement department-title '" v-for="(departmentItem) in requirementData && requirementData" :key="departmentItem.label" @click="getDepartment(departmentItem)">
                  <div class="department-text">{{departmentItem.label}}</div>
              </div>
            </div>
            <div v-if="departmentAction === departmentItem.name" style="padding: 24px 43px 0px 15px;" v-for="(departmentItem) in requirementData && requirementData" :key="departmentItem.label" class="department-main2">
              <div v-for="(positionItem) in departmentItem.requirementData && departmentItem.requirementData" :key="positionItem.label">
                <div>
                  <div class="requirement">
                    <div class="title-icon"></div>
                    <div class="title-text">{{positionItem.title}}</div>
                  </div>
                  <div v-if="positionItem.text" style="padding-top: 12px;">
                    <div class="requirement" v-for="(textItem,textIndex) in positionItem.text && positionItem.text" :key="textIndex" :style="{paddingBottom: textIndex == positionItem.text.length - 1 ? '28px' : '16px'}">
                      <div class="requirement-icon"></div>
                      <div class="requirement-text" v-if="textItem">{{textItem}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <go-top></go-top>
  </div>
</template>

<script>
import Sidebar from '@/components/sidebar/Sidebar'
import {Tabs,TabPane} from 'element-ui'
import goTop from "../../common/go-top.vue";
// import MapContainer from '../../common/map-container'

export default {
  name: 'GotoContent',
  components: {
    Sidebar,
    Tabs,
    TabPane,
    goTop
  },
  data(){
      return {
        dateList: [
            '2019~至今',
            '2008~2018',
            '1998~2008',
            '1988~1998'
        ],
        childDateListLatest: ['2020','2019'],
        childDateList1: ['2016','2015','2014','2013','2012','2011','2009','2008'],
        childDateList2: ['2007','2005','2003','2001','2000','1999','1998'],
        childDateList3: ['1997','1995','1993','1990','1988'],
        dateIndex: 0,
        childDateIndex: 0,
        events: [
            [
              [
                {text: '8月 亚商资本荣获36氪颁布的最受创业者欢迎创投机构奖，私募股权投资机构价值榜&最受LP认可投资机构。'},
                {text: '同年，掌门人正经塾完成多家龙头上市公司的走访，包括万科，万通，美的，360，泰康等。'},
              ],
              [
                {text: '2019年初，亚商推出对话企业掌门人的《掌门人说》特辑，深受行业投资人欢迎。'},
                {text: '9月，举办与掌门人同行，致敬共和国70周年主题活动，活动邀请了数十位中国各个行业的龙头企业掌门人，听其对中国经济、企业发展、行业潜力等的真知灼见。'},
                {text: '12月，亚商资本项目卓易信息科创板上市，同月亚商投顾30专家工作会议圆满召开。'},
                {text: '同年，亚商资本获得融中颁布的年度创投机构TOP50，36氪颁布的中国最受创业者欢迎，中国国民新品牌领域最具发现力奖。'},
                {text: '结合对话掌门人，由亚商集团董事长陈琦伟先生发起，掌门人正经塾正式成立。'},
              ]
            ],
            [
              [
                  {
                      text:'2016年3月亚商集团成立亚商读书会，为学界商界的交流与沟通搭建了稳固有效的平台。'
                  },
                  {
                      text:'8月亚商投顾携手扬州金融办、证券时报，在扬州举办亚商并购基金的成立仪式。也是亚商在多领域的有一大布局。2016年亚商资本所投资的，东方时尚（603377）、达威股份（300535）、丝路视觉（300556）先后分别登陆上海主板和深圳创业板；延续15年的好成绩，在资本寒冬的投资行业中，亚商继续以高于同行业的现金回报和颇有成绩的项目得到投资人的信任和支持。'
                  },
                  {
                      text:'同年，亚商资本所投资的项目获得“投中2015最佳退出案例TOP10”；清科集团颁发的“2016年中国创业投资机构100强”第28名；融资中国“融中2016中国创业投资机构50强”第23名；上海股权投资协会颁布的“PEAS2016年度最佳投资机构”，并亚商投资的丝路视觉获得“PEAS2016年度明星项目”。'
                  }
              ],
              [
                  {
                      text: '2015年1月，由上海华谊集团联合亚商资本共同发起创立的“亚商华谊产业创新基金”正式成立。'
                  },
                  {
                       text: '5月，“轻奢温生活 五月盛放突破•2015亚商资本LP大会”及年度答谢晚宴在宁波柏悦酒店圆满举行。7月，亚商集团与湖州市政府签署战略合作框架协议。'
                  },
                  {
                       text: '12月，由亚商资本与湖州市政府共同开办的“象牛大学堂”首期开班仪式在湖州举行。同年，亚商资本荣获“投中2015年中国最具创新力中资创业投资机构TOP10”奖项，及清科集团颁发的“2015年中国创业投资机构50强”、“2015年中国本土创业投资机构50强”奖项。'
                  },
                  {
                       text: '同年，亚商资本所投资的“科旭网络”（股票代码834257）、“鼎合远传”（股票代码834257）登陆新三板挂牌交易。也是在2015年，亚商资本所投资的美康生物（300439）、迅游科技（300467）先后登陆创业板。为亚商基金的投资者们带来了丰厚的回报。'
                  }

              ],
              [
                  {
                      text: '2014年1月，亚商资本获得PEAS 2013年度最佳投资机构TOP 10殊荣，亚商资本创始合伙人、总裁张琼获得PEAS 2013年度杰出影响力人物奖，亚商资本管理合伙人丁承获得PEAS 2013年度最佳投资人TOP 10称号。'
                  },
                  {
                       text: '5月，“突破2014•亚商资本LP大会”及年度答谢晚宴在佘山国际高尔夫俱乐部圆满举行。'
                  }
              ],
              [
                  {
                      text: '2013年5月，“更好的2013年！”亚商资本年度LP联谊在上海顺利举行。近80位亚商资本LP、新老朋友汇聚一堂。同年,在PEAS 2012股权投资年度评选中，亚商资本合伙人丁承获颁“最有价值投资人”；亚商资本投资的宁波美康生物科技股份有限公司荣获“最具成长价值企业”殊荣。'
                  }
              ],
              [
                  {
                      text: '2012年4月，亚商集团董事长陈琦伟当选为上海股权投资协会新一届理事会理事长。3月，亚商资本俱乐部系列活动“移动•互联网的机遇与挑战”在上海举行，四十多位关注移动互联行业发展的行业专家、专注移动互联的投资人、大力自主创新的移动互联网企业创业者汇聚一堂，共同探讨2012年中国移动互联网的发展趋势。6月，2012年6月16日，由亚商集团董事长、亚商资本创始合伙人、上海交通大学教授陈琦伟发起并主持的“创业成功和经营成功--资本眼光”上海交通大学安泰论坛在上海举行。现场气氛热烈，互动积极。亚商资本投资的成都红旗连锁股份有限公司在深交所中小板挂牌上市（股票代码002697.SZ）'
                  }
              ],
              [
                  {
                      text: '2011年1月, 亚商资本在第二届国际LP&GP合作高峰会上，当选为“2010中国风险投资十佳卓越管理团队”。3月，“创业加速器”荣获由《创业家》杂志主办的“2011年度最受尊敬的创业天使评选”活动之“最佳天使投资伙伴”奖！ 4月，在由ChinaVenture主办的第五届中国创业投资暨私募股权投资年度排行榜颁奖典礼上，亚商资本获得“2010年度中国最具特色投资团队”殊荣，亚商资本创始合伙人、总裁张琼女士同时被授予“2010年度中国十大最佳创业投资人物”称号。同年，亚商资本旗下苏州亚商创投、杭州创业加速器正式成立。'
                  }
              ],
              [
                  {
                      text: '2009年1月，亚商集团开始组织年度 “亚商老友会”活动。在“老友会”上记录了亚商人成长心声的20周年纪念文集《通世济人达天下—亚商：作为一种生活方式》正式发布。4月，由亚商集团发起，各方企业家的共同投资下，亚商资本旗下 “天使基金”成立。同时，成都亚商的新基金业宣告成立，作为农业龙头企业的圣农发展也成功在深圳挂牌交易。由上海市金融办发起组织的上海市股权投资协会正式成立，亚商资本入选成为发起理事单位，张琼总裁当选协会理事。同年，亚商资本下新组建的两个基金类投资公司“亚商创业”和“成都亚商”以及新组建的“上海创业加速器”都成为亚商主业发展的新动力，由亚商咨询拆分出的“亚商锐明”也快速起航。'
                  }
              ],
              [
                  {
                      text: '2008年8月，亚商集团用慈善捐助义演的方式来庆祝成立20周年，由亚商出资赞助、上海市民政局、上海市老年基金会、亚商集团、上海文化广播影视集团联合主办的“生命礼赞”大型交响音乐会－暨四川大地震抗震救灾人员慰问演出在东方艺术中心举行。同年，亚商资本旗下基金公司投资的另外二家企业升达林业和卫士通也正式上市。'
                  }
              ]

            ],
            [
              [
                  {
                      text: '2007年，亚商资本被评为“2007中国十佳最具影响的私募股权投资机构”。同时亚商资本俱乐部——“达之会”成立，成功举行《达》杂志的创刊发布仪式。同年，由国际管理学会和中国管理大会共同评选，亚商企业咨询有限公司被评为“卓越管理咨询公司奖”。资本旗下的基金所投资的中航三鑫在深圳挂牌上市。'
                  }
              ],
              [
                  {
                      text: '亚商集团与长江经济联合发展集团结成战略联盟，作为战略合作伙伴双方将在咨询、投资及投资服务等多种领域展开全面合作。同年，成功举行第七届“50强”上市公司发展力高峰论坛---“2005年中国资本市场大变局”。'
                  }
              ],
              [
                  {
                      text: '2003年，经过几年的耕耘，亚商咨询在企业战略重组和整合的管理咨询方面形成了明确的核心竞争力，成为中国最具有战略执行力的管理咨询公司。亚商企业咨询股份有限公司已拥有注册资本5000万元，是中国本地规模最大的咨询企业之一。'
                  }
              ],
              [
                  {
                      text: '2001年，第三届50强论坛“全球视野的企业竞争力”在海南博鳌成功举办。政府高级官员、著名企业家、著名专家学者达270位共聚博鳌，在全球视野下探讨中国企业发展的竞争力，成为当年极具影响力的一场大型盛会。'
                  }
              ],
              [
                  {
                      text: '2000年1月，在广州九龙湖成功举行了第二届亚商老友会。同年初，创业加速器正式增资扩股成功，开始在全国以增值服务引导投资的创新风险投资模式快速发展的新阶段。同年，原上海亚洲商务投资咨询有限公司正式更名为上海亚商投资顾问有限公司。4月, 亚商资本旗下的基金类投资公司“成都新兴”投资的成都国腾电子，获中国证监会发审会审核通过。'
                  }
              ],
              [
                  {
                      text: '1999年，亚商又创新性的推出股权激励、管理层收购等咨询服务等涉及产权变革的咨询服务，成为数十家上市公司和集团公司的激励顾问。同年，亚商咨询董事长陈琦伟先生从硅谷考察受到启发，认为当时的中国资本市场普遍缺乏对企业发展潜力的应有重视，具有前瞻性地提议举办一个提倡可持续发展理念的活动，该项提议很快得到《中国证券报》的积极响应。第一届“中证-亚商  中国上市公司发展潜力论坛”在上海召开，议题引起与会150多位企业家和专家的强烈共鸣，“中国最具发展潜力上市公司50强”评选被誉为中国最有价值的评选活动，论坛也成为中国优秀企业的决策层一年一度的盛会。'
                  }
              ],
              [
                  {
                      text: '1998年，亚商企业咨询股份有限公司成立。亚商咨询聚焦于涉及企业战略重组和整合的管理咨询，迅速树立了品牌。许多上市公司邀请亚商策划收购兼并方案，一些西部地区的地方政府如成都、重庆、甘肃等也请亚商做他们的资产重组顾问。财经界也将“资产重组”与亚商的名字联系在了一起。'
                  }
              ]
            ],
              [
                  [
                      {
                          text: '1997年，厚积薄发的亚商成功策划了中远收购众城、上房收购嘉丰两起大型国企业集团的买壳上市案例，在证券界树立了“并购专家”的品牌。'
                      }
                  ],
                  [
                      {
                          text: '1995年，亚商召开了“依托资本市场收购兼并”专题研讨会，吸引了大量的上市公司和大型企业成为客户。'
                      }
                  ],
                  [
                      {
                          text: '1993年，亚商召开了“上市公司规范管理研讨会”，这是中国证券市场第一次针对上市公司治理结构的研讨活动，引起了监管部门的重视，而且还引来了几十家如饥似渴的上市公司。亚商成功的找到了转型方向。当年，对万科收购申华进行了精心的策划，使亚商咨询成就了中国证券史上的又一个第一。在以后短短的几个月内亚商又涉足了小飞乐、爱使等多个早期购并案例，积累了宝贵的经验。'
                      }
                  ],
                  [
                      {
                          text: '1990年，沪深证交所建立，证券市场快速发展，亚商的业务由此改变成为专营证券咨询业的公司，亚商的证券咨询孕育出了不少当赫赫有名的股评人士，而且还开创了不少证券咨询业的先河，如传真咨询、股民服务俱乐部、股市讲座沙龙等。'
                      }
                  ],
                  [
                      {
                          text: '1988年，亚商企业咨询有限公司前身上海亚洲商务投资咨询公司成立，注册资金仅为10万元，是一家引导外商在华投资的咨询公司。'
                      }
                  ]
            ]



        ],
        addrList: [
            {
                addrName: '亚商集团',
                addrDetail: '上海市长宁区延安西路2558号1号楼',
                telephone: '电话：021-62959001',
                fax: '传真：021-62958055'
            },
            {
                addrName: '亚商资本',
                addrDetail: '上海市长宁区延安西路2558号1号楼',
                telephone: '电话：021-62959001',
                fax: '传真：021-62958054'
            },
            {
                addrName: '亚商投顾',
                addrDetail: '上海市普陀区曹杨路1888号星光耀广场',
                telephone: '客服热线：4000098005',
                fax: '投诉电话：021-62590530'
            },
            {
              addrName: '亚商智讯',
              addrDetail: '上海市普陀区曹杨路1888号星光耀广场',
              telephone: '电话：021-61923028',
              // fax: '传真：021-62958055'
            },
            {
                addrName: '亚商资本(深圳)',
                addrDetail: '广东省深圳市南山区西丽街道留仙大道创智云城B2栋4层',
                telephone: '电话：0755-23910785',
                fax: '传真：0755-23910785'
            }
        ],
        departmentAction: 'departmentOne',//部门
        positionAction: 'consultant',//职位
        requirementData:[{
          label: '研究员',
          name: 'departmentOne',
          requirementData:[{
            title: '岗位职责',
            text:[
              '完成一级市场投资项目的执行工作，包括前期洽谈、工资计划制定实施、项目评估与考察、行业研究、估值分析、投资方案的制定及建立项目投资档案；',
              '负责及协调项目的尽职调查工作，全面详细了解项目情况，为投资决策提供可靠依据；',
              '对项目进行投资可行性分析，完成项目分析报告；',
              '分析并撰写上市公司及掌门人的信息，撰写研究分析报告；',
              '研究市场的宏观方面的信息，包括市场动态、技术发展动态、国家与地方政策变化及趋势等，并收集产品与市场信息；'
            ]
          },{
            title: '任职资格',
            text:[
              '国内外重点院校本科及以上学历；',
              '具有3年以上的上市公司研究经验；',
              '具有良好的经济管理、财务金融知识基础与分析技能；',
              '具备出色的逻辑分析能力，较强的学习能力、沟通协调能力；诚实守信，勤奋努力，责任心强、具有良好的职业素养和团队协作精神；',
              '工作积极主动、勤奋上进，责任心强，富有团队精神；',
              '此岗位同步在招聘研究实习生。'
            ]
          },{
            title: '薪资：10-15K'
          }],
        },{
          label: '市场总监',
          name: 'departmentTwo',
          requirementData:[{
            title: '岗位职责',
            text:[
              '根据公司发展战略，结合产品和运营，制定年度运营计划，涵盖活动、互动营销、渠道推广等，通过策划、组织并执行各类品牌活动，打造平台影响力，提升现有客户黏性，获取新客户资源；',
              '各类品牌活动及营销活动的策划、组织、执行及品质管理，建立数据化分析及完善的管理制度；',
              '对同类市场分析调研，定期汇总市场运营整体情况并制定相应合作/学习方向；',
              '与部门同事配合并监督工作落实情况；'
            ]
          },{
            title: '任职要求',
            text:[
              '本科及以上学历；',
              '具有营销、广告、公关、大客户平台运营经验优先；',
              '具备大局观念及战略眼光；',
              '具有极强的责任心，良好的沟通能力、活动策划能力、创意执行能力；',
              '具有良好的服务意识，抗压能力，团队协作精神；',
              '具有一定的业务管理能力；',
              '对金融科技有一定的了解。'
            ]
          },{
            title: '薪资：15-16K'
          }]
        },{
          label: 'BD',
          name: 'departmentThree',
          requirementData:[{
            title: '岗位职责',
            text:[
              '根据商学院市场招生计划，负责开拓与落实课程招生；',
              '协调完成教务工作并关注学员动态；',
              '负责定期组织学员与校友的相关活动；',
              '积极宣传学院及课程，定期推送相关信息资料；',
              '规划并落实课程宣讲等市场推广活动；',
              '负责课程学员的建档管理，做好关系维护；',
              '完成领导交办的各项工作。'
            ]
          },{
            title: '任职要求',
            text:[
              '本科以上学历，教育、市场营销、经济金融以及相关专业，具有MBA教育背景优先；',
              '具有3年及以上商学院工作经验，教育行业背景优先；',
              '勤奋敬业，注重细节，严谨自律，良好的组织协调能力和学习能力；',
              '具有良好的团队协作精神和职业素养，抗压能力和危机处理能力强；',
              '具有良好的交流沟通技巧；',
              '优秀的英语听说读写能力，熟练运用word、excel、ppt等办公软件。'
            ]
          },{
            title: '薪资：30-40K'
          }]
        }]
      }
  },
  methods: {
      tabNav: function(index){
        this.dateIndex = index;
        this.childDateIndex = 0;
      },
      tabChildNav: function(index){
        this.childDateIndex = index;
      },
      getDepartment(departmentItem){
        this.departmentAction = departmentItem.name;
        this.positionAction = 'consultant';
      }
  }
}
</script>

<style scoped>
.detail{
    flex: 1;
    min-width: 1200px;
}
.detail .main{
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 48px;
}
.detail .current-local{
    text-align: left;
    line-height: 54px;
    font-size: 14px;
}
.detail .current-local span:last-child{
    color: #003B83;
}
.current-local .arrow-bold{
    font-weight: 600;
}
.detail-cont{
    width: 992px;
    padding: 48px 80px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 48px;
    border: 1px solid #ced7e2;
}
.introduce p,.founder p{
    text-align: left;
    margin-bottom: 24px;
    color: #666;
    line-height: 24px;
}
.introduce p.title,.founder p.title{
    font-size: 20px;
    font-weight: 600;
    color: #333;
}
.introduce p.summary,.founder p.founder-intro{

    text-align: justify;
}
.founder p.founder-intro{
    text-indent: 2em;
    width: 610px;
}
.developHistory .oneList{
    /*width: 480px;*/
  margin-bottom: 24px;
  text-align: left;
}
.developHistory li{
    color: #C1C1C1;
    cursor: pointer;
    display: inline-block;
    text-align: left;
}
.developHistory .oneList li{
    width: 160px;
    font-size: 18px;
}
.developHistory .active{
    color: #003B83;
}
.developHistory .childDateList{
    width: 100%;
    display: table;
    table-layout: fixed;
}
.developHistory .childDateList li{
    width: 76px;
    display: table-cell;
    line-height: 24px;
    font-size: 15px;
}
.developHistory .line{
    border-bottom: 1px solid #ADC2D6;
    box-sizing: border-box;
    margin: 6px 0 24px 0;
}
.majorEvent p{
    text-align: justify;
    line-height: 24px;
    color: #666;
    margin-bottom: 24px;
}
.founder1{
    position: relative;
}
.founder .founder-pic{
    position: absolute;
    top: 48px;
    right: 0;
}
.contactUs{
    position: relative;
  height:auto;
}
.contactUs ul{
    width: 400px;
    text-align: left;
    margin-bottom: 24px;
}
.contactUs ul:nth-child(3){
    margin-top: 34px;
}
.contactUs ul:nth-child(5){
  margin-top: 34px;
  padding-bottom: 77px;
}
.contactUs li{
    color: #666;
    line-height: 24px;
}
.contactUs li .mr20{
    margin-right: 20px;
}
.contactUs li.title{
    font-size: 18px;
    font-weight: 600;
    color: #333;
}
.contactUs .map-box{
    position: absolute;
    top: 0;
    right: 0;
}
.contactUs .map-box .mb96{
    margin-bottom: 43px;
}
.contactUs .map-box p{
    text-align: right;
    color: #666;
    font-size: 12px;
    margin-top: 6px;
}
.joinUs{
  text-align: left;
}
/*.joinUs img{ width: 100%;}*/
.title-icon{
  width: 3px;
  height: 20px;
  background: #043A7A;
  opacity: 1;
}
.title-text{
  margin:2px 0px 2px 6px;
  height: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #043A7A;
  line-height: 16px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
}
.department-title{
  width: 37%;
  position: relative;
  height: 18px;
  font-size: 18px;
  font-weight: 400;
  color: #9F9F9F;
  line-height: 18px;
  border-right: 1px solid #9F9F9F;
  justify-content: center;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
}
.department-title:last-child {
  width: 26%;
  border-right: 0px;
}
.department-title:hover,
.department-title-action{
  font-weight: 500;
  color: #043A7A;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
}
.department-title-action:before{
  content: '';
  display: inline-block;
  position: absolute;
  bottom: -12px;
  width: 100px;
  height: 0;
  border-bottom: 3px solid #043A7A;
}
.department-text{
  cursor: pointer;
}
.requirement{
  display: flex;
  flex-flow: row;
}
.requirement-icon{
  width: 6px;
  height: 6px;
  background: #043A7A;
  border-radius: 50%;
  opacity: 1;
  margin:8px 8px 0px 11px;
}
.requirement-text{
  flex:1;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 23px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
}
.tab-main{
  background: #FFFFFF;
  box-shadow: 0px 3px 20px 1px rgba(33,85,162,0.17);
  border-radius: 3px;
  opacity: 1;
  padding:26px 21px 39px;
}
</style>




// WEBPACK FOOTER //
// src/components/gotoContent/GotoContent.vue